import {
    STORE_LINKED_USERS, STORE_LOCATION_DETAIL,
    STORE_ROLES,
} from '../../constants/userManagement';
import {ROLE_DEPTH_AND_ORDER} from "../../../components/settings/ManageUsers/constants";

const initialState = {
    users: [],
    roles: [],
    locationDetail: null
}

const setRoles = (actionRoles) => {
    let newRoles = []
    for (const [key] of Object.entries(ROLE_DEPTH_AND_ORDER)) {
        if (actionRoles.includes(key)) {
            newRoles.push(key)

        }
    }
    return newRoles
}

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_LINKED_USERS:
            return {
                ...state,
                users: action.users
            }
        case STORE_ROLES:
            return {
                ...state,
                roles: setRoles(action.roles)
            }
            case STORE_LOCATION_DETAIL:
            return {
                ...state,
                locationDetail: action.data
            }
        default:
            return state
    }
}